
<template>
  <div class="my-account-tabs">
    <div class="tabs-box">
      <template
        v-if="
          accountObj.entPayAdminAccount ||
          accountObj.entPayMemberAccount ||
          accountObj.entMemberAccount
        "
      >
        <div
          class="tabs-item tabs-item-user"
          :class="active == accoutnTypeObj.user ? 'active active-after' : ''"
          @click="accoutnTypeClick(accoutnTypeObj.user)"
        >
          <div class="tabs-icon-box tabs-item-tow">
            <img
              src="../../../../picture/my/account-user.png"
              class="tabs-icon"
            />
          </div>
          <div class="tabs-name">个人账户</div>
        </div>
        <div
          class="tabs-item tabs-item-ent"
          :class="active == accoutnTypeObj.ent ? 'active active-after' : ''"
          @click="accoutnTypeClick(accoutnTypeObj.ent)"
        >
          <div class="tabs-icon-box tabs-item-tow">
            <img
              src="../../../../picture/my/account-ent.png"
              class="tabs-icon"
            />
          </div>
          <div class="tabs-name">
            {{
              accountObj.entPayAdminAccount || accountObj.entPayMemberAccount
                ? "企业统付"
                : "企业个付"
            }}
          </div>
        </div>
      </template>
      <div v-else class="tabs-item-user tabs-item active" style="width: 100%">
        <div class="tabs-icon-box">
          <img
            src="../../../../picture/my/account-user.png"
            class="tabs-icon"
          />
        </div>
        <div class="tabs-name">个人账户</div>
      </div>
    </div>
    <!-- 个人账户 -->
    <template v-if="active == accoutnTypeObj.user">
      <div class="account-info-box">
        <div class="account-info-item" @click="goRecharge">
          <div class="account-info-value">
            {{
              accountObj.personalAccount
                ? accountObj.personalAccount.availableAmount
                : 0 || 0
            }}
          </div>
          <div class="account-info-name">可用余额(元)</div>
        </div>
        <div class="account-info-item" @click="goCoupon">
          <div class="account-info-value">{{ accountObj.couponNum || 0 }}</div>
          <div class="account-info-name">优惠券(张)</div>
        </div>
        <div class="account-info-item" @click="goIntegral">
          <div class="account-info-value">{{ points }}</div>
          <div class="account-info-name">积分</div>
        </div>
      </div>
      <pi-my-card-list :accountObj="accountObj" :configData="configData" type="user"></pi-my-card-list>
    </template>
    <!-- 企业管理员 -->
    <template
      v-else-if="active == accoutnTypeObj.ent && accountObj.entPayAdminAccount"
    >
      <div class="ent-name">{{ entData.entName || "-" }}</div>
      <div class="account-info-box">
        <div
          class="account-info-item"
          v-for="(item, index) in entAdminList"
          :key="index"
        >
          <div class="account-info-value">{{ entData[item.key] || 0 }}</div>
          <div class="account-info-name">{{ item.name }}</div>
        </div>
      </div>
      <pi-my-card-list :accountObj="accountObj"
        :entData="entData"
        :configData="configData"
        type="entAdmin"
      ></pi-my-card-list>
      <div class="my-account-btn">
        <div class="my-account-btn-flex">
          <pi-button type="primary" @click="goEntRecharge" block>充值</pi-button>
        </div>
        <div class="my-account-btn-flex">
          <pi-button @click="goEntRefund" block>退款</pi-button>
        </div>
      </div>
    </template>
    <!-- 企业支付 -->
    <template
      v-else-if="active == accoutnTypeObj.ent && accountObj.entPayMemberAccount"
    >
      <div class="ent-name">
        企业账户({{ accountObj.entPayMemberAccount.entName || "-" }}) 成员:{{
          accountObj.entPayMemberAccount.entSubUserName || "-"
        }}
      </div>
      <div class="account-info-box">
        <div
          class="account-info-item"
          v-for="(item, index) in entList"
          :key="index"
        >
          <div class="account-info-value">
            {{ accountObj.entPayMemberAccount[item.key] || 0 }}
          </div>
          <div class="account-info-name">{{ item.name }}</div>
        </div>
      </div>
      <pi-my-card-list :accountObj="accountObj"
        :entData="accountObj.entPayMemberAccount"
        :configData="configData"
        type="ent"
      ></pi-my-card-list>
    </template>
    <!-- 企业个付 -->
    <template
      v-else-if="active == accoutnTypeObj.ent && accountObj.entMemberAccount"
    >
      <div class="ent-name">
        {{ accountObj.entMemberAccount.entName || "-" }}
      </div>
      <pi-my-card-list :accountObj="accountObj"
        :entData="accountObj.entMemberAccount"
        :configData="configData"
        type="entUser"
      ></pi-my-card-list>
    </template>
  </div>
</template>
<script>
import myCardList from "../pi-my-card-list/pi-my-card-list.vue";
import { getUserPoints, getEntOverview } from "@/common/api";
export default {
  name: "pi-my-account-tabs",
  components: {
    [myCardList.name]: myCardList
  },
  data() {
    return {
      points: 0,
      accoutnTypeObj: {
        user: "1",
        ent: "2",
      },
      active: "1",
      entAdminList: [
        { name: "支付总额(元)", key: "totalPayment" },
        { name: "可用余额(元)", key: "balanceAmount" },
        { name: "企业本月电量(度)", key: "elecOfCurrMonth" },
        { name: "总成员", key: "memberCount" },
        { name: "统付成员", key: "payMemberCount" },
        { name: "个付成员", key: "nonpayMemberCount" },
      ],
      entList: [
        { name: "支付总额(元)", key: "amount" },
        { name: "本月电量(度)", key: "elecOfCurrMonth" },
      ],
      entData: {},
    };
  },
  props: {
    accountObj: {
      type: Object,
      default: () => {
        return {};
      },
    },
    configData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  mounted(){
    this.getUserPoints();
    
  },
  methods: {
    /**
     * 切换账户
     * @param {*} e
     */
    accoutnTypeClick(type) {
      this.active = type;
      if (
        type == this.accoutnTypeObj.ent &&
        this.accountObj.entPayAdminAccount &&
        Object.keys(this.entData).length == 0
      ) {
        this.getEntOverview();
      }
      this.$common.save('my-tabs-active',this.active);
    },
    /**
     * 获取积分
     */
    async getUserPoints() {
      let ret = await getUserPoints({}, { loading: false });

      if (ret.status === 0) {
        let data = ret.data[0];
        this.points = data.points;
      }
    },
    /**
     * 跳转我的余额
     */
    async goRecharge() {
      this.$router.push({
        name: "money",
        query: {
          accountPkId: this.accountObj.accountPkId,
        },
      });
    },
    /**
     * 跳转优惠券
     */
    async goCoupon() {
      this.$router.push({
        name: "my-coupon",
        query: { accountPkId: this.accountObj.personalAccount.accountPkId },
      });
    },
    /**
     * 跳转积分页面
     */
    async goIntegral() {
      this.$router.push({
        name: "my-integral-info",
        query: { chargeUserPkId: this.accountObj.chargeUserPkId },
      });
    },
    /**
     * 获取企业账户的信息
     */
    async getEntOverview() {
      let ret = await getEntOverview({
        entUserPkId: this.accountObj.entPayAdminAccount.entUserPkId,
      });
      
      if (ret.status == 0) {
        let data = ret.data[0] || {};
        this.entData = data;
        this.entData.totalPayment = data.payOrderStat.totalPayment || 0;
      }
    },
    /**
     * 企业管理员点击充值
     */
    goEntRecharge() {
      this.$router.push("/recharge?userType=3");
    },
    goEntRefund(){
      this.$router.push("/account-refund?userType=3");
    }
  },
};
</script>
<style lang="less" scoped>
.my-account-tabs {
  margin-top: 0.2rem;
}
.tabs-box {
  position: relative;
  height: 0.7rem;
}

.tabs-item {
  padding-right: 0.64rem;
  font-size: 0;
  color: #fff;
  width: 4.95rem;
  position: absolute;
  top: 0;
  opacity: 0.6;
  z-index: 1;
  // right: 0;
  // text-align: right;
  box-sizing: border-box;
  transition: 0.3s all;
}
.tabs-item.active {
  opacity: 1;
  z-index: 2;
  // left: 0;
  // text-align: left;
  // padding-left: 0.64rem;
}
.tabs-item.tabs-item-user {
  background: linear-gradient(90deg, #5c5a66 0%, #4b4957 100%);
  box-shadow: inset 0px 0.01rem 0.01rem 0px #c5c5c8;
  border-radius: 0.16rem 0.16rem 0px 0px;
  left: 0;
  padding-left: 0.64rem;
}
.tabs-item.tabs-item-user.active-after::after {
  background: linear-gradient(90deg, #5c5a66 0%, #4b4957 100%);
}
.tabs-item.tabs-item-ent.active-after::after {
  background: linear-gradient(90deg, #7fe1ff 0%, #4c6dff 100%);
  left: -0.1rem;
  transform: skew(-15deg);
}
.tabs-item.active-after::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0.1rem;
  width: 100%;
  height: 100%;
  transform: skew(15deg);
  border-radius: 0.16rem 0.16rem 0px 0px;
  z-index: -1;
}
.tabs-item.tabs-item-ent {
  background: linear-gradient(90deg, #7fe1ff 0%, #4c6dff 100%);
  box-shadow: 0px 0px 0.1rem 0px rgba(239, 239, 244, 0.5),
    inset 0px 1px 1px 0px #bdcaf6;
  border-radius: 0.16rem 0.16rem 0px 0px;
  right: 0;
  text-align: right;
}
.tabs-item.tabs-item-ent.active {
  background: linear-gradient(90deg, #7fe1ff 0%, #4c6dff 100%);
}
.tabs-item.tabs-item-ent.active.active-after::after {
  background: linear-gradient(90deg, #7fe1ff 0%, #4c6dff 100%);
}
.tabs-item .tabs-icon-box {
  position: absolute;
  right: 0.18rem;
  top: 0.18rem;
  width: 0.34rem;
  height: 0.34rem;
}
.tabs-item.tabs-item-user  .tabs-icon-box {
  left: 0.18rem;
}
.tabs-item .tabs-icon-box .tabs-icon {
  width: 100%;
  height: 100%;
}
.tabs-item .tabs-name {
  margin: 0.15rem 0;
  font-size: 0.28rem;
  line-height: 0.4rem;
  display: inline-block;
  vertical-align: top;
}
.ent-name {
  font-size: 0.24rem;
  line-height: 0.33rem;
  color: #666;
  padding: 0.02rem 0.2rem;
  background: rgba(189, 202, 246, 0.2);
}
.account-info-box {
  display: flex;
  flex-wrap: wrap;
  background-color: #fff;
}
.account-info-box .account-info-item {
  width: 33.33%;
  box-sizing: border-box;
  padding: 0.3rem 0;
  text-align: center;
}
.account-info-value {
  font-size: 0.5rem;
  line-height: 0.6rem;
  color: #333;
}
.account-info-name {
  font-size: 0.2rem;
  line-height: 0.28rem;
  margin-top: 0.1rem;
  color: #999999;
}
.my-account-btn{
  margin-top: 0.2rem;
  display: flex;
  .my-account-btn-flex{
    flex: 1;
  }
  .my-account-btn-flex:last-child{
    margin-left: 0.12rem;
  }
}
</style>